module.exports = __webpack_public_path__ + "img/namsan_detail.c54b594b.jpg";